interface FavouritesIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const FavouritesIcon = (props: FavouritesIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  const style = {
    fill: 'none',
    stroke: fillColor,
    strokeLineCap: 'round',
    strokeLineJoin: 'round',
  }

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <circle style={style} cx="19.75" cy="20.09" r="12.09" />
      <path
        style={style}
        d="M19.75,26.69c-1.32,0-6.7-4.35-7.35-7.29s.6-4.48,1.52-5.18a3.72,3.72,0,0,1,3.7-.42c1.25.6,2.12,2.9,2.12,2.9s.87-2.3,2.12-2.9a3.72,3.72,0,0,1,3.7.42c.92.7,2.17,2.24,1.52,5.18S21.07,26.69,19.75,26.69Z"
      />
    </svg>
  )
}

export default FavouritesIcon
